const PARAM_GLICOSE_GROUP = 74;
const PARAM_GLICOSE_UNIT = 'g/dia';
const PARAM_UI_DIA_UNIT = 'ui/dia';
const UNIT_ML_ID = 1;
const ADMINISTRATION_WAYS_PERIPHERAL = 'PERIFERICA';
const ADMINISTRATION_WAYS_CENTRAL = 'CENTRAL';
const ADMINISTRATION_WAYS_PERIPHERAL_LABEL = 'Periférica';
const ADMINISTRATION_WAYS_CENTRAL_LABEL = 'Central';
const INFUSION_TIME_OPTIONS = [
  {
    text: '12 horas',
    value: 12,
  },
  {
    text: '13 horas',
    value: 13,
  },
  {
    text: '14 horas',
    value: 14,
  },
  {
    text: '15 horas',
    value: 15,
  },
  {
    text: '16 horas',
    value: 16,
  },
  {
    text: '17 horas',
    value: 17,
  },
  {
    text: '18 horas',
    value: 18,
  },
  {
    text: '19 horas',
    value: 19,
  },
  {
    text: '20 horas',
    value: 20,
  },
  {
    text: '21 horas',
    value: 21,
  },
  {
    text: '22 horas',
    value: 22,
  },
  {
    text: '23 horas',
    value: 23,
  },
  {
    text: '24 horas',
    value: 24,
  },
];
const PRESCRIPTION_VALIDATION_TYPE_WARNING = 'ALERTA';
const PRESCRIPTION_VALIDATION_TYPE_ERROR = 'IMPEDITIVO';
const PRESCRIPTION_REFRESH_TIME = 6000000;
const TRANSCRIPTION_REFRESH_TIME = 6000000;
export {
  PARAM_GLICOSE_GROUP,
  PARAM_GLICOSE_UNIT,
  UNIT_ML_ID,
  ADMINISTRATION_WAYS_PERIPHERAL,
  ADMINISTRATION_WAYS_CENTRAL,
  ADMINISTRATION_WAYS_PERIPHERAL_LABEL,
  ADMINISTRATION_WAYS_CENTRAL_LABEL,
  INFUSION_TIME_OPTIONS,
  PRESCRIPTION_VALIDATION_TYPE_WARNING,
  PRESCRIPTION_VALIDATION_TYPE_ERROR,
  PARAM_UI_DIA_UNIT,
  PRESCRIPTION_REFRESH_TIME,
  TRANSCRIPTION_REFRESH_TIME,
};
